import { type ProColumns, ProTable } from "@ant-design/pro-components";
import {
	fetchADAccountList,
	fetchAsyncAdvAccount,
	fetchCennectAdvAccount,
	fetchUnCennectAdvAccount
} from "@/api/modules/AdAccount";
import { Button, Form, Input, message, Modal, Select, Switch, Tag, Tooltip } from "antd";
import { useEffect, useRef, useState } from "react";
import { accountType } from "@/pages/AdAccount/interface.typing";
import { useDebounce } from "@/utils/util";
import { useTranslation } from "react-i18next";
import refreshIcon from "@/assets/icons/account/刷新.png";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import AutomatedRulesModal from "./RuleModal";

export default function AccountTable(props: any) {
	const { t } = useTranslation();

	const { facebookProfiles, actionRef } = props;
	const { currentUser, currentTeam } = useSelector(state => state.global);

	const [total, setTotal] = useState(0);
	const [connectLimit, setConnectLimit] = useState(0);
	const [filterParams, setFilterParams] = useState({
		queryData: "",
		facebookUserId: "",
		isActive: ""
	});

	const [showRuleModal, setShowRuleModal] = useState(false);
	const [currentAccount, setCurrentAccount] = useState();

	useEffect(() => {
		if (currentUser) {
			setConnectLimit(currentUser.currentPlan?.connectedAdAccountsLimit || 0);
		}
	}, [currentUser]);

	useEffect(() => {
		if (actionRef?.current) {
			actionRef?.current?.reload();
		}
	}, [currentTeam]);

	const facebookProfilesOption = [
		{
			label: t("account.table.search.profile.placeholder"),
			value: ""
		}
	];
	facebookProfiles.forEach(item => {
		facebookProfilesOption.push({
			label: item.name,
			value: item.facebookUserId
		});
	});

	const fetchData = async params => {
		let res = await fetchADAccountList({
				...params,
				...filterParams
			});

		setTotal(res.data.map?.activeNum);
		return {
			success: true,
			data: res.data.list.map((item, index) => {
				return {
					...item,
					key: index
				};
			}),
			total: res.data.total
		};
	};

	const handleSyncAdvAccount = () => {
		fetchAsyncAdvAccount().then(res => {
			if (res.code === 200) {
				message.success(t("account.table.sync.message.success"));
				if (actionRef?.current) {
					actionRef?.current?.reload();
				}
			} else {
				message.error(res.message);
			}
		});
	};

	const searchRules = useDebounce(value => {
		setFilterParams(...value);
		if (actionRef?.current) {
			actionRef?.current?.reload();
		}
	}, 800);

	const columns: ProColumns<accountType>[] = [
		{
			title: <span style={{ marginLeft: "1rem" }}>{t("account.table.column.connected")}</span>,
			key: "connected",
			width: "15%",
			render: record => (
				<div className="AdAccount_table_advName_cell">
					<Switch
						checked={record.isActive}
						onChange={value => {
							// if (total >= connectLimit) {
							// 	message.error(t("account.table.column.connected.limit"));
							// 	return;
							// }

							if (value) {
								fetchCennectAdvAccount({ advIds: [{ advId: record.advId, facebookUserId: record.facebookUserId }] }).then(res => {
									if (res.code === 200) {
										setTotal(total + 1);
										if (actionRef?.current) {
											actionRef?.current?.reload();
										}
									}
								});
							} else {
								Modal.confirm({
									width: 500,
									title: t("account.table.disconnect.modal.title"),
									content: (
										<div style={{ marginTop: "16px" }}>
											<span>{t("account.table.disconnect.modal.text")}</span>
											<ul style={{ marginTop: "10px" }}>
												<li>{t("account.table.disconnect.modal.text.item")}</li>
											</ul>
										</div>
									),
									onOk: () => {
										fetchUnCennectAdvAccount({ advIds: [{ advId: record.advId, facebookUserId: record.facebookUserId }] }).then(
											res => {
												if (res.code === 200) {
													setTotal(total - 1);
													if (actionRef?.current) {
														actionRef?.current?.reload();
													}
												}
											}
										);
									}
								});
							}
						}}
					/>
				</div>
			)
		},
		{
			title: t("account.table.column.advName"),
			dataIndex: "advName",
			key: "advName",
			width: "40%",
			render: (_, record) => <div className="AdAccount_table_advName">{record.advName}</div>
		},
		{
			title: (
				<div>
					{t("account.table.column.status")}
					<Tooltip title={t("account.table.column.status.tips")}>
						<QuestionCircleOutlined style={{ marginLeft: "0.5rem" }} />
					</Tooltip>
				</div>
			),
			dataIndex: "status",
			key: "status",
			width: "15%",
			render: (_, record) => {
				if ([1,8,9].indexOf(record.status)>=0) {
					return <Tag color="green">{t("account.table.column.status.enable")}</Tag>;
				} else {
					return <Tag color="red">{t("account.table.column.status.Restricted")}</Tag>;
				}
			}
		},
		{
			title: t("account.table.column.advId"),
			dataIndex: "advId",
			key: "advId"
		},
		{
			title: "操作",
			render: (_, record) => {
				return (
					<a
						onClick={() => {
							console.log("1111");
							setShowRuleModal(true);
							setCurrentAccount(record);
						}}
					>
						{t("account.table.operation.view binding")}
					</a>
				);
			}
		}
	];

	console.log("showModal", showRuleModal);
	return (
		<div className="account_table">
			<div className={"title"}>{t("account.table.title")}</div>
			<div className={"subtitle"}>{t("account.table.description")}</div>
			<div className="header">
				<Form layout={"inline"}>
					<Form.Item>
						<Input
							size={"large"}
							style={{ width: "14rem" }}
							placeholder={t("account.table.search.name.placeholder")}
							width={256}
							onChange={event => {
								searchRules({
									...filterParams,
									queryData: event.target.value
								});
							}}
						/>
					</Form.Item>
					<Form.Item>
						<Select
							size={"large"}
							style={{ width: "12rem" }}
							placeholder={t("account.table.search.profile.placeholder")}
							options={facebookProfilesOption}
							onChange={value => {
								searchRules({
									...filterParams,
									facebookUserId: value
								});
							}}
						/>
					</Form.Item>
					<Form.Item>
						<Select
							size={"large"}
							style={{ width: "14rem" }}
							placeholder={t("account.table.search.account.placeholder")}
							options={[
								{
									label: t("account.table.search.account.choice1"),
									value: "all"
								},
								{
									label: t("account.table.search.account.choice2"),
									value: "connected"
								},
								{
									label: t("account.table.search.account.choice3"),
									value: "notConnected"
								}
							]}
							onChange={value => {
								let isActive;
								if (value === "connected") {
									isActive = 1;
								} else if (value === "notConnected") {
									isActive = 0;
								} else {
									isActive = null;
								}
								searchRules({
									...filterParams,
									isActive: isActive
								});
							}}
						/>
					</Form.Item>
					<Form.Item>
						<Button
							size={"large"}
							key="sync"
							onClick={() => handleSyncAdvAccount()}
							style={{
								width: "auto",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								border: "1px solid #565BDD"
							}}
						>
							<img src={refreshIcon} alt="" style={{ width: "1rem" }} />
							<span style={{ marginLeft: "4px", fontSize: "14px", color: "#565BDD" }}>{t("account.table.sync.button")}</span>
						</Button>
					</Form.Item>
				</Form>
				<div>
					<span
						style={{
							fontSize: "0.875rem",
							lineHeight: "1.25rem",
							color: "#707793"
						}}
					>
						{t("account.table.search.connectedAccount")}
						{total}/{connectLimit}
					</span>
				</div>
			</div>
			{/*<div className={"hidden_tip"}>1 ad account was hidden because it cannot be connected. Show all ad accounts</div>*/}
			<ProTable
				columns={columns}
				request={fetchData}
				actionRef={actionRef}
				pagination={{
					// defaultPageSize: 10
					pageSize: 20
				}}
				search={false}
				toolBarRender={false}
				style={{
					margin: "2rem"
				}}
			/>

			<AutomatedRulesModal
				open={showRuleModal}
				currentAccount={currentAccount}
				onClose={() => {
					setShowRuleModal(false);
				}}
			/>
		</div>
	);
}
